module.exports = __webpack_public_path__ + "img/feature_1.3a203239.svg";